export function mockOpening(name: string): string {
  // Short on purpose: the old opening was six bullet points of rules before
  // any help, and most people left after the first reply. The essentials stay:
  // it's an AI, not a therapist, the conversation isn't kept, and 112.
  return `Bună, ${name}. Sunt Zenyra, asistentul AI al Mindtale.

Te ascult câteva minute și apoi îți recomand un psihoterapeut potrivit pentru tine. Primul pas cu el poate fi o discuție gratuită de 20 de minute.

Nu sunt terapeut și nu pun diagnostice. Conversația noastră nu rămâne la Mindtale. Dacă ești în pericol acum, sună la 112.`;
}
